import React from 'react'
import Main from '../Main'
import UserHeader from './UserHeader'
import UserContactInfo from './UserContactInfo'

const User = props => {
  return (
    <Main>
      <div>
        <UserHeader user={props.user}/>

        <div className="row">

          <div className="col-sm-4">
            <div className="island group-login-info">
              <h2>Login Information</h2>
              <div className="field">
                <div className="field-label">Email:</div>
                <div className="field-item">{props.user.user_info.email}</div>
              </div>

              <div className="field">
                <div className="field-label">Password:</div>
                <div className="field-item">********</div>
              </div>
            </div>
          </div>

          <div className="col-sm-4">
            <UserContactInfo user={props.user}/>
          </div>

          <div className="col-sm-4">
            {/* <div className="island group-notifications">
              <h2>Notifications</h2>

              <div className="field field-name-field-child-updates field-type-list-text field-label-above">
                <div className="field-label">Child updates:&nbsp;</div>
                <div className="field-items">
                  <div className="field-item even">By Email</div>
                </div>
              </div>

              <div className="field field-name-field-news-updates field-type-list-text field-label-above">
                <div className="field-label">General news updates:&nbsp;</div>
                <div className="field-items">
                  <div className="field-item even">By Email</div>
                </div>
              </div>

              <div className="field field-name-field-alerts field-type-list-text field-label-above">
                <div className="field-label">Community updates:&nbsp;</div>
                <div className="field-items">
                  <div className="field-item even">By Email</div>
                </div>
              </div>
            </div> */}
          </div>

        </div>

      </div>
    </Main>
  )
}

export default User
